var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PreviousDocumentFetchURL, appointmentDetailsGetByIdAPI, createInspectionBajajURL, createInspectionUrl } from '../../api/url';
import { APISchema, EParentModuleName, ESystemName, LOCAL_STORAGE_KEYS, Module, StatusEnum, isModuleConfig } from '../../constants';
import { getDocumentByIdAPIFunction, showLoader } from '../../redux/commonSlice';
import { getListAPI, setState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getLocalStorageItem } from '../../utils/storageHelper';
import DocumentConversionComponent from './documentConversionComponent';
import { t } from 'i18next';
var delay = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var DocumentConversionIndex = function () {
    var documentId = useParams().documentId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var documentDetailsGetById = useAppSelector(function (state) { return state.crud; }).documentDetailsGetById;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _a = useState(true), isShowSkeleton = _a[0], setShowSkeleton = _a[1];
    var _b = useState(false), isDisabled = _b[0], setIsDisabled = _b[1];
    var _c = useState(""), awaitngMessage = _c[0], setAwaitingMessage = _c[1];
    var _d = useState(false), isLoadingShow = _d[0], setIssLoadingShow = _d[1];
    // const isDisabled: boolean = [StatusEnum.Closed, StatusEnum.Complete].includes(
    //     documentDetailsGetById?.data?.Key || ""
    // );
    var isMounted = useRef(true);
    var state = useLocation().state;
    useEffect(function () {
        dispatch(setState({
            key: "customerComplaintDataImageAndAudio",
            value: {}
        }));
        isMounted.current = true;
        initialDetails(3, 10000);
        return function () {
            isMounted.current = false; // Cleanup to set the ref to false
        };
    }, []);
    var initialDetails = function (retries, interval) { return __awaiter(void 0, void 0, void 0, function () {
        var attempt, _result$payload, _result$payload2, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attempt = 1;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= retries)) return [3 /*break*/, 9];
                    if (!isMounted.current)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 7, , 8]);
                    setIsDisabled(true);
                    setIssLoadingShow(true);
                    return [4 /*yield*/, dispatch(getDocumentByIdAPIFunction({
                            key: 'documentDetailsGetById',
                            url: "".concat(appointmentDetailsGetByIdAPI).concat(documentId, "/Get")
                        }))];
                case 3:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.data && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                        if (!(result.payload.value.data.Key == StatusEnum.Awaiting || result.payload.value.data.Key == StatusEnum.Error)) {
                            parentDocumentView(result.payload.value.data);
                            setShowSkeleton(false);
                            setIsDisabled(false);
                            setIssLoadingShow(false);
                            return [2 /*return*/]; // Exit the loop if successful
                        }
                    }
                    if (!(attempt < retries)) return [3 /*break*/, 5];
                    return [4 /*yield*/, delay(interval)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setIssLoadingShow(false);
                    setAwaitingMessage(t("No response from CDMS. Please try creating PreJC again."));
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _a.sent();
                    console.error("API call attempt ".concat(attempt, " failed:"), error_1);
                    return [3 /*break*/, 8];
                case 8:
                    attempt++;
                    return [3 /*break*/, 1];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var parentDocumentView = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var request, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    request = {
                        InstallBaseId: item === null || item === void 0 ? void 0 : item.InstallBaseId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        SystemName: "Inspection"
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "preDocumentFetch",
                            url: PreviousDocumentFetchURL,
                            request: request
                        }))];
                case 2:
                    result = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleHeaderClick = function () {
        var _documentDetailsGetBy, _documentDetailsGetBy2;
        if (((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.Key) == StatusEnum.Error || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.Key) == StatusEnum.Awaiting) && state !== null && state !== void 0 && state.isFromAppointmentTaskDetails) {
            navigate("/appoinment-tasksDetails/".concat(documentId));
        }
        else {
            navigate('/inspection');
        }
    };
    return /*#__PURE__*/ React.createElement(DocumentConversionComponent, {
        SystemName: ESystemName.Inspection,
        parentComponent: EParentModuleName.Inspection,
        APISchema: APISchema.Inspection,
        documentId: documentId !== null && documentId !== void 0 ? documentId : '',
        apiRequestPayload: {
            InspectionId: documentId !== null && documentId !== void 0 ? documentId : ''
        },
        handleHeaderClick: function () { return handleHeaderClick(); },
        handleMoreIconClick: function () { return console.log("second"); },
        createDocumentURL: Module == isModuleConfig.Bajaj ? createInspectionBajajURL : createInspectionUrl,
        createAndEditFlow: {
            isInspection: "Create"
        },
        IsFromParentAPt: true
        // isShowSkeleton ={isShowSkeleton}
        ,
        isDisabled: isDisabled,
        AwaitingMessage: awaitngMessage,
        loadingShow: isLoadingShow
    });
};
export default DocumentConversionIndex;
